import { useMemo, useState } from "react";

const activeReservationStatuses = ["PENDING", "APPROVED", "CHECKED_OUT"];

const toDateInput = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const startOfLocalDay = (value) => {
  const date = value instanceof Date ? value : new Date(value);
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

const rangesOverlap = (startA, endA, startB, endB) => startA <= endB && endA >= startB;

export default function AvailabilityCalendar({
  trailerId,
  reservations,
  selectedStartDate,
  selectedEndDate,
  onSelectDate
}) {
  const [monthDate, setMonthDate] = useState(new Date());
  const today = useMemo(() => startOfLocalDay(new Date()), []);
  const todayKey = toDateInput(today);
  const firstDay = new Date(monthDate.getFullYear(), monthDate.getMonth(), 1);
  const daysInMonth = new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 0).getDate();
  const offset = (firstDay.getDay() + 6) % 7;
  const cells = [];
  const activeReservations = reservations.filter((reservation) => (
    reservation.trailerId === Number(trailerId) &&
    activeReservationStatuses.includes(reservation.status)
  ));

  for (let i = 0; i < offset; i += 1) cells.push({ key: `empty-${i}`, empty: true });

  for (let day = 1; day <= daysInMonth; day += 1) {
    const date = new Date(monthDate.getFullYear(), monthDate.getMonth(), day);
    const dateKey = toDateInput(date);
    const past = startOfLocalDay(date) < today;
    const unavailable = activeReservations.some((reservation) => (
      rangesOverlap(
        startOfLocalDay(date),
        startOfLocalDay(date),
        startOfLocalDay(reservation.startDate),
        startOfLocalDay(reservation.endDate)
      )
    ));

    cells.push({
      key: dateKey,
      day,
      past,
      today: dateKey === todayKey,
      unavailable
    });
  }

  return (
    <div className="calendar">
      <div className="calendar-header">
        <button className="button secondary" onClick={() => setMonthDate(new Date(monthDate.getFullYear(), monthDate.getMonth() - 1, 1))}>Vorige</button>
        <div className="calendar-title">{monthDate.toLocaleDateString("nl-BE", { month: "long", year: "numeric" })}</div>
        <button className="button secondary" onClick={() => setMonthDate(new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 1))}>Volgende</button>
      </div>
      <div className="calendar-grid">
        {["Ma", "Di", "Wo", "Do", "Vr", "Za", "Zo"].map((day) => <div key={day} className="calendar-weekday">{day}</div>)}
        {cells.map((cell) => (
          <button
            key={cell.key}
            type="button"
            disabled={cell.empty || cell.past || cell.unavailable}
            className={`calendar-day${cell.empty ? " muted" : ""}${cell.past ? " past" : ""}${cell.unavailable ? " unavailable" : ""}${cell.today ? " today" : ""}${cell.key === selectedStartDate || cell.key === selectedEndDate ? " selected" : ""}`}
            onClick={() => onSelectDate?.(cell.key)}
            title={cell.past ? "Datum ligt in het verleden" : cell.unavailable ? "Deze datum is bezet" : "Beschikbaar"}
          >
            {cell.empty ? "" : cell.day}
          </button>
        ))}
      </div>
      <div className="calendar-legend">
        <span className="badge success">Beschikbaar</span>
        <span className="badge danger">Bezet</span>
      </div>
    </div>
  );
}
